import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDk9netLDv5f_fwhmJRJoZ6635tjmWmfXU",
  },
  installComponents: true,
});
